import { feedItems } from "@/mocks/gua";

export default function FeaturedCard() {
  const item = feedItems[0];
  return (
    <section className="mx-auto max-w-6xl px-4 pt-10 md:px-6 md:pt-14">
      <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
        <div className="grid grid-cols-1 lg:grid-cols-5">
          <div className="flex flex-col justify-center gap-4 p-6 md:p-9 lg:col-span-3">
            <span className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-fire-fill" /> {item.tag}
            </span>
            <h2 className="text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
              {item.title}
            </h2>
            <p className="max-w-2xl text-sm leading-6 text-foreground-700 md:text-[15px] md:leading-7">
              {item.excerpt}
            </p>
            <div className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-600">
              <span className="inline-flex items-center gap-1">
                <i className="ri-hashtag" /> {item.meta}
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-time-line" /> {item.time}
              </span>
              <span className="inline-flex items-center gap-1 font-medium text-foreground-800">
                <i className="ri-fire-line" /> 热度 {item.heat}
              </span>
            </div>
            <div className="mt-2">
              <a
                href="#"
                className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
              >
                查看完整梳理
                <i className="ri-arrow-right-up-line" />
              </a>
            </div>
          </div>
          <div className="relative min-h-[240px] lg:col-span-2 lg:min-h-[360px]">
            <img
              src="https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20breaking%20online%20gossip%20news%20scene%2C%20warm%20cream%20paper%20background%2C%20stacked%20vintage%20newspaper%20clippings%20and%20a%20magnifying%20glass%20hovering%20above%2C%20floating%20speech%20bubbles%20and%20question%20marks%2C%20subtle%20chili%20pepper%20motif%20suggesting%20hot%20scoop%2C%20warm%20terracotta%20and%20amber%20color%20palette%2C%20clean%20minimal%20composition%20with%20generous%20negative%20space%2C%20soft%20paper%20texture&width=900&height=720&seq=gua-hero-2026-a1&orientation=landscape"
              alt="色瓜网猛料合集-联名发布会翻车事件配图"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}